import { VALUE_SET_COMPUTABLE_NAMES } from '../constants';
import { useValueSet } from './useValueSet';

/**
 * Fetches community engagement value sets for interaction and procedure creation.
 * The expectation (for now) is each of these value sets will return a single default concept except procedure codes.
 */

export const useInteractionConcepts = () => {
  const procedures = useValueSet(
    VALUE_SET_COMPUTABLE_NAMES.community_engagement_procedures,
  );
  const type = useValueSet(VALUE_SET_COMPUTABLE_NAMES.community_engagement);
  const interactionState = useValueSet(VALUE_SET_COMPUTABLE_NAMES.interactionState);
  const interactionClass = useValueSet(VALUE_SET_COMPUTABLE_NAMES.interactionClass);
  const procedureState = useValueSet(VALUE_SET_COMPUTABLE_NAMES.procedureState);
  const procedureUnit = useValueSet(VALUE_SET_COMPUTABLE_NAMES.procedureUnit);

  const typeRecord = type?.concepts?.[0];
  const typeConcept = typeRecord ?
    {
      id: typeRecord.id,
      displayName: typeRecord.display ?? typeRecord.attributes?.display ?? '',
    } :
    null;

  const interactionConcepts = {
    stateConceptId: interactionState?.conceptId,
    classConceptId: interactionClass?.conceptId,
  };

  const procedureConcepts = {
    stateConceptId: procedureState?.conceptId,
    unitConceptId: procedureUnit?.conceptId,
  };

  const isLoading = procedures.isLoading ||
    type.isLoading ||
    interactionState.isLoading ||
    interactionClass.isLoading ||
    procedureState.isLoading ||
    procedureUnit.isLoading;

  return {
    typeConcept,
    procedureOptions: procedures.options,
    interactionConcepts,
    procedureConcepts,
    isLoading,
  };
};
